/*
 * © 2021 Sukoa AG <Interactive Technologies> http://www.sukoa.com
 */

import DataLayerEvent from "../DataLayerEvent";

class RemoveFromCartDL extends DataLayerEvent {
    constructor(ecommerce) {
        super();
        this.ecommerce = ecommerce;
    }

    generateParameters() {
        this.getParameters().event = 'remove_from_cart';
        this.getParameters().ecommerce = this.ecommerce
    }

}

export default RemoveFromCartDL;
